const cards = [
  {
    title: '国产剧精选合集',
    desc: '古装、都市、悬疑、涉案，国产好剧一站式收录，每日更新最新剧集。',
    label: '热门分类',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20and%20modern%20drama%20collage%20style%2C%20traditional%20costume%20and%20urban%20scenes%20blend%2C%20warm%20cinematic%20lighting%2C%20elegant%20Chinese%20cultural%20aesthetic%2C%20soft%20atmospheric%20composition%2C%20film%20poster%20visual%20style&width=500&height=350&seq=cards-gc-01&orientation=landscape',
  },
  {
    title: '韩剧热播专区',
    desc: '最新韩剧同步上线，爱情、悬疑、奇幻全覆盖，第一时间追韩流。',
    label: '海外剧场',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20and%20modern%20visual%20collage%2C%20Seoul%20cityscape%20with%20cherry%20blossoms%2C%20warm%20pastel%20tones%2C%20elegant%20couple%20silhouette%2C%20soft%20dreamy%20atmosphere%2C%20Korean%20entertainment%20aesthetic&width=500&height=350&seq=cards-hj-02&orientation=landscape',
  },
  {
    title: '美剧口碑佳作',
    desc: 'IMDb高分美剧一网打尽，科幻、悬疑、史诗巨制，原声字幕畅快看。',
    label: '海外剧场',
    img: 'https://readdy.ai/api/search-image?query=American%20TV%20drama%20epic%20visual%20collage%2C%20New%20York%20skyline%20and%20fantasy%20elements%2C%20dramatic%20cinematic%20lighting%2C%20modern%20urban%20and%20sci-fi%20blend%2C%20professional%20film%20poster%20style%2C%20high%20contrast%20atmosphere&width=500&height=350&seq=cards-mj-03&orientation=landscape',
  },
  {
    title: '动漫动画大全',
    desc: '国漫日漫美漫全覆盖，热血、治愈、奇幻总有你爱的那一款。',
    label: '动漫专区',
    img: 'https://readdy.ai/api/search-image?query=Anime%20and%20animation%20colorful%20visual%20collage%2C%20Japanese%20anime%20and%20Chinese%20donghua%20style%20blend%2C%20vibrant%20colors%20and%20dynamic%20action%20poses%2C%20fantasy%20and%20modern%20elements%2C%20energetic%20and%20artistic%20atmosphere&width=500&height=350&seq=cards-dm-04&orientation=landscape',
  },
  {
    title: '综艺纪录片精选',
    desc: '热门综艺、高分纪录片，轻松娱乐与深度内容随心切换。',
    label: '专题精选',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20and%20documentary%20visual%20collage%2C%20stage%20lights%20and%20nature%20scenes%20blend%2C%20warm%20entertaining%20atmosphere%2C%20talk%20show%20and%20wildlife%20elements%2C%20modern%20TV%20production%20aesthetic%2C%20soft%20colorful%20lighting&width=500&height=350&seq=cards-zy-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          热门剧集
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#ranking"
              className={`group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${i === 0 ? 'aspect-[2/1]' : 'aspect-[3/2]'}`}>
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded whitespace-nowrap">
                    {card.label}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}